import clone from './clone';

const s3Host = 'https://s3-us-west-1.amazonaws.com/ubinfo-s3/ubshop-upload';

export { clone, s3Host };



// WEBPACK FOOTER //
// ./src/utils/index.js